import { ContactComponent } from './contact.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
export const routes: Routes = [
    {
        path: '',
        component: ContactComponent,
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonComponentsModule,
        FormsModule,
        CommonModule
    ],
    declarations: [
        ContactComponent
    ],
    exports: [
    ]
})

export class ContactModule {

}
